import { ChangeEvent, SetStateAction } from 'react';

type ChangeEventField = ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

export const onChangeString = (e: ChangeEventField, setState: (value: SetStateAction<string>) => void) => {
  setState(e.target.value);
};

export const onChangeObj = <T>(e: ChangeEventField, setState: (value: SetStateAction<T>) => void) => {
  setState(prevState => ({
    ...prevState,
    [e.target.name]: e.target.value
  }));
};

export const reorderItems = <T>(list: T[], startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
